// Chooses the url a media element should load, and is deliberately free of imports so it can be
// unit tested: everything else on this path pulls in the api client and app config.
//
// REFUSES to fall back to the stored bucket url when a credential could not be obtained. That
// fallback used to exist, and it was the reason the audited route was optional rather than
// guaranteed: a failed mint rendered an identical-looking image while the read went unrecorded, so
// the accounting quietly understated what had been disclosed. Throwing makes the failure visible
// instead — the caller turns it into a missing image and a Sentry error, which is the honest
// outcome while a read we cannot account for is not.
//
// The one remaining pass-through is a media item that carries NO download link, which means the
// server had no audited route to point at. Every note surface now offers one, so what is left is:
// an object we do not host — a social login copies the account picture straight from the identity
// provider, so a care recipient's photo is routinely a googleusercontent.com url the download
// route cannot sign — or anything served by a deploy older than the route.
//
// Refusing THOSE would break a working feature rather than close a hole: they are not in our
// bucket, so closing it does not affect them and there is nothing of ours to audit. The server
// decides this, not the client: it offers a link only where it can serve one, so the absence of a
// link IS the signal. Guessing here instead is what blanked the avatar of every care recipient
// whose photo came from a Google account.
export const buildAuthorizedMediaUrl = (params: {
    url: string;
    href?: string;
    token?: string;
    apiBaseUrl: string;
}): string => {
    const { url, href, token, apiBaseUrl } = params;

    if (!href) {
        return url;
    }

    if (!token) {
        throw new Error('cannot authorise a media read: no media token');
    }

    const separator = href.includes('?') ? '&' : '?';
    return `${apiBaseUrl}${href}${separator}authorization=${encodeURIComponent(`JWT ${token}`)}`;
};
